export class RouteUtils {
  static readonly PAGES = {
    LOGIN: 'acompanhar-proposta',
    FORM_LIST: 'forms-list',
    FORM_SELLER_PF: 'seller-info-pf'
  };

  static readonly ENTRYPOINTS = {
    AUTH: 'auth',
    GET_SELLERS: 'get-sellers',
    UPDATE_INDIVIDUAL_SELLER: 'update-individual-seller',
    UPDATE_CORPORATE_SELLER: 'update-corporate-seller',
    FINISH_SELLER_UPDATE: 'finish-seller-update',
    GET_SELLER_PERCENTAGES: 'get-seller-percentages',
    UPDATE_SELLER_PERCENTAGES: 'update-seller-percentages',
    GET_PROFESSIONS: 'get-professions',
    GET_ADDRESS: 'get-address',
    GET_CITIES: 'get-cities'
  };
}
